import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { CarouselModule } from 'ngx-owl-carousel-o'
import { ArticleTopicsComponent } from './article-topics.component'
import { ArticleTopicsDesktopComponent } from './article-topics-desktop/article-topics-desktop.component'
import { ArticleTopicsMobileComponent } from './article-topics-mobile/article-topics-mobile.component'
@NgModule({
  declarations: [
    ArticleTopicsComponent,
    ArticleTopicsDesktopComponent,
    ArticleTopicsMobileComponent,
  ],
  exports: [
    ArticleTopicsComponent,
    ArticleTopicsDesktopComponent,
    ArticleTopicsMobileComponent,
  ],
  imports: [CommonModule, SharedModule, CarouselModule],
})
export class ArticleTopicsModule {}
